var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.progress === 0
    ? _c("li", { attrs: { id: "submit-el" } }, [
        _c("input", {
          staticClass: "btn-submit-red",
          attrs: { type: "submit", value: "Request Transcription" }
        }),
        _vm._v(" "),
        _vm.errorMessage !== null
          ? _c("div", { staticClass: "error-message" }, [
              _vm._v(_vm._s(_vm.errorMessage))
            ])
          : _vm._e()
      ])
    : _c("li", { attrs: { id: "submit-el" } }, [
        _c("div", { staticClass: "progress" }, [
          _vm._v("Progress:\n        "),
          _c("span", { staticClass: "progress-pct" }, [
            _vm._v(_vm._s(_vm.progress.toFixed(1)) + " %")
          ])
        ]),
        _vm._v("\n    Uploading, please wait...\n    "),
        _c("div", { staticClass: "progress-bar-outer" }, [
          _c("div", {
            staticClass: "progress-bar-inner",
            style: { width: _vm.progress + "%" }
          })
        ]),
        _vm._v(" "),
        _vm.errorMessage !== null
          ? _c("div", { staticClass: "error-message" }, [
              _vm._v(_vm._s(_vm.errorMessage))
            ])
          : _vm._e()
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-142f9c86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142f9c86","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/progress.vue
// module id = 18
// module chunks = 0